<template>
  <b-modal title="Detalhes da Particula Magnética" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Material:" label-for="material" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="material" v-model="template.material" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Técnica:" label-for="tecnica" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="tecnica" v-model="template.tecnica" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Via:" label-for="via" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="via" v-model="template.via" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Decantação:" label-for="dec" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="dec" v-model="template.decantacao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Corrente:" label-for="corrente" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="corrente" v-model="template.corrente" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Temperatura:" label-for="temperatura" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="temperatura" v-model="template.temperatura" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Superfície:" label-for="superficie" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="superficie" v-model="template.superficie" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Norma:" label-for="norma" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="norma" v-model="template.norma" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Partículas:" label-for="particula" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.particula">
              <b-form-select-option v-for="particula of getConsumiveis" v-bind:key="particula.id" :value="particula"
                >{{ particula.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Condicionador:" label-for="condicionador" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.distensor">
              <b-form-select-option v-for="distensor of getConsumiveis" v-bind:key="distensor.id" :value="distensor"
                >{{ distensor.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Procedimento:" label-for="procedimento" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.procedimento">
              <b-form-select-option v-for="documento of getDocumentos" v-bind:key="documento.id" :value="documento.numero"
                >{{ documento.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Instrumento:" label-for="instrumento" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.instrumento">
              <b-form-select-option v-for="instrumento of getInstrumentos" v-bind:key="instrumento.id" :value="instrumento"
                >{{ instrumento.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label-cols-sm="2" label="Observação:" label-align-sm="center">
            <b-form-textarea v-model="template.observacao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col cols="6">
          <b-form-group label="Inspetor:" label-for="inspetor" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.inspetor">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <template-pm-modal ref="templateParticula" @loadTemplate="loadTemplate($event)" />

    <template #modal-footer>
      <b-button variant="info" @click="templates()">Templates</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useDocumentoStore } from "@/stores/DocumentoStore";
import { useConsumivelStore } from "@/stores/ConsumivelStore";
import { useInstrumentoStore } from "@/stores/InstrumentoStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { storeToRefs } from "pinia";
import ParticulaMagnetica from "@/models_reports/ParticulaMagnetica";
import InspecaoTemplateModal from "@/components/modals/template/InspecaoTemplateModal";

export default {
  name: "ModalDeTemplatePM",

  components: {
    "template-pm-modal": InspecaoTemplateModal,
  },

  data() {
    return {
      show: false,
      template: new ParticulaMagnetica(),
    };
  },

  methods: {
    templates() {
      this.$refs.templateParticula.call();
    },

    loadTemplate(template) {
      this.template.observacao = template.observacao;
      for (var i = 0; i < template.itens.length; i++) {
        this.template.itens[i].quantidade = template.itens[i].quantidade;
        this.template.itens[i].descricao = template.itens[i].descricao;
        this.template.itens[i].local = template.itens[i].local;
        this.template.itens[i].tipo = template.itens[i].tipo;
        this.template.itens[i].dimensao = template.itens[i].dimensao;
        this.template.itens[i].laudo = template.itens[i].laudo;
      }
    },

    call(pm) {
      this.show = !this.show;
      this.template = pm;
    },
  },

  setup() {
    const store = useSgcqStore();
    const documentoStore = useDocumentoStore();
    const { getDocumentos } = storeToRefs(documentoStore);
    const instrumentoStore = useInstrumentoStore();
    const { getInstrumentos } = storeToRefs(instrumentoStore);
    const consumivelStore = useConsumivelStore();
    const { getConsumiveis } = storeToRefs(consumivelStore);
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      documentoStore,
      getDocumentos,
      instrumentoStore,
      getInstrumentos,
      consumivelStore,
      getConsumiveis,
      profissionalStore,
      getProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped></style>
